<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2>
                {{ pageTitle }}
            </h2>
        </v-col>
        <div>
            <v-col cols="12" :class="`tabs ${!id ? 'stepper' : ''}`">
                <v-tabs
                    v-model="tab"
                    show-arrows
                    :class="`${!!errorsInTabs.find((x) => x == tab) ? 'v-tabs--error' : ''}`"
                >
                    <v-tab
                        v-for="(title, index) in stepperHeaders"
                        :key="index"
                        :class="`${!!errorsInTabs.find((x) => x == index) ? 'v-tab--error' : ''} ${
                            !!sections[index].isValid ? 'v-tab--valid' : ''
                        }`"
                        :disabled="
                            !(
                                sections[index].isValid ||
                                (sections[index - 1] && sections[index - 1].isValid) ||
                                section > index
                            ) && !id
                        "
                    >
                        <div class="tab">
                            <div class="icon-error">
                                <v-icon
                                    v-if="!!errorsInTabs.find((x) => x == index)"
                                    class="error-icon"
                                    left
                                    dense
                                    color="red"
                                    >mdi-alert
                                </v-icon>
                            </div>
                            <div class="title-wrap">{{ title }}</div>
                            <div v-if="!id" class="icon-wrap">
                                <v-icon class="wrap">icon icon-stepper</v-icon>
                                <v-icon
                                    v-if="!sections[index].isValid"
                                    :class="`${index !== sections.length - 1 ? 'step' : 'step last-step'}`"
                                    v-text="index !== sections.length - 1 ? 'mdi-chevron-right' : 'mdi-minus'"
                                ></v-icon>
                                <v-icon v-if="sections[index].isValid" class="step valid">mdi-check</v-icon>
                            </div>
                        </div>
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" :touchless="!id">
                    <v-tab-item
                        v-for="(component, index) in sections"
                        :key="index"
                        transition="scroll-x-reverse-transition"
                        reverse-transition="scroll-x-transition"
                    >
                        <v-form :ref="'test'" v-model="component.isValid">
                            <component :is="component.component" :key="index"></component>
                            <stepper-control
                                v-model="tab"
                                :is-disabled="!(component.isValid || index === sections.length - 1) && !id"
                                :last="index === sections.length - 1"
                                :hide-steps="!!!id"
                            >
                                <template v-if="index === sections.length - 1 || !!id">
                                    <consultant-form-actions
                                        :disabled="!!errorsInTabs.length && !id"
                                    ></consultant-form-actions>
                                </template>
                            </stepper-control>
                        </v-form>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </div>
        <!-- <div class="stepper">
            <v-stepper v-model="section">
                <v-stepper-header>
                    <template v-for="(n, index) in stepperHeaders">
                        <v-stepper-step
                            :key="`${n}-step`"
                            :complete="section > n"
                            :step="index + 1"
                            :editable="id ? true : section > index"
                            :rules="[
                                () => sections[index].isValid || _.values(consultantErrorMessages).every(_.isEmpty),
                            ]"
                            :class="sections[index].isValid && !id ? 'v-stepper__step--valid' : false"
                            error-icon="mdi mdi-close"
                            edit-icon="mdi mdi-check"
                        >
                            {{ n }}
                        </v-stepper-step>

                        <v-divider v-if="n !== stepperHeaders" :key="n"></v-divider>
                    </template>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content v-for="(component, index) in sections" :key="index" :step="index + 1">
                        <v-form :ref="'consultant-form-' + index" v-model="component.isValid">
                            <stepper-control
                                v-model="section"
                                :is-disabled="!(component.isValid || index === sections.length - 1)"
                                :last="index === sections.length - 1"
                            ></stepper-control>
                            <component :is="component.component" :key="index"></component>
                        </v-form>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            stepperHeaders: [t('consultants::stepper.title.main_details'), t('consultants::stepper.title.out_hours')],
            section: 1,
            tab: 0,
            sections: [
                { component: 'consultant-form-main-details', isValid: !!this.id },
                { component: 'consultant-form-out-hours', isValid: !!this.id },
            ],
            tabsErrors: {
                0: [
                    'gmc_number',
                    'company_name',
                    'surname',
                    'forename',
                    'can_be_sent_letters',
                    'is_rcop_member',
                    'dms_id',
                    'address',
                    'post_code',
                    'post_code',
                    'phone',
                    'fax',
                    'email',
                    'is_registered',
                ],
                1: [
                    'out_of_hours_contact_name',
                    'out_of_hours_contact_phone',
                    'out_of_hours_contact_fax',
                    'out_of_hours_contact_email',
                ],
            },
        };
    },
    computed: {
        pageTitle() {
            if (!(can('api.v1.consultants.store') && can('consultants.create'))) {
                return 'Preview Consultant';
            }
            return this.id ? t('consultants::page.title.edit_consultant') : t('consultants::page.title.new_consultant');
        },
        errorsInTabs() {
            const errors = this.$store.state.consultants.errorMessages.consultant;
            const Errors = [];
            const errorsInTabs = [];
            Object.keys(errors).forEach((val) => {
                if (errors[val] && errors[val].length) {
                    Errors.push(val);
                }
            });
            Object.keys(this.tabsErrors).forEach((tab) => {
                Object.values(this.tabsErrors[tab]).forEach((error) => {
                    if (Errors.includes(error)) {
                        errorsInTabs.push(tab);
                    }
                });
            });
            return _.sortedUniq(errorsInTabs);
        },
        consultantErrorMessages() {
            return this.$store.state.consultants.errorMessages.consultant;
        },
        isFormsValid() {
            return !!this.sections.find((x) => !x.isValid);
        },
    },
    watch: {
        steps(val) {
            if (this.section > val) {
                this.section = val;
            }
        },
    },
    created() {
        this.loadConsultant();
    },
    methods: {
        backToList() {
            return this.$root.goTo(route('consultants.index'));
        },
        loadConsultant() {
            if (_.isEmpty(this.id)) {
                this.loading = false;
                return;
            }

            axios
                .get(
                    route('api.v1.consultants.show', {
                        consultant: this.id,
                    })
                )
                .then((response) => {
                    const data = response.data.data;

                    this.$store.dispatch('consultants/loadConsultant', data);
                })
                .catch((error) => {
                    this.$root.notify('error', error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
